import { Button, Dialog, DialogActions, DialogTitle, useTheme } from '@mui/material'
import React, { useState } from 'react'
import UnsavedChangesWarningImage from '../../assets/images/unsavedChangesWarningImage.png'

interface PayContractorDialogProps {
    /**
     * dialogType - type of dialog (single or multiple) - default is single (one contractor)
     * @type {string}
     */
    dialogType?: 'single' | 'multiple'
    onContractorPaid: () => void
}
const PayContractorDialog: React.FC<PayContractorDialogProps> = ({
    dialogType = 'single',
    onContractorPaid,
}: PayContractorDialogProps) => {
    const theme = useTheme()

    const [isDialogOpen, setIsDialogOpen] = useState<boolean>(false)

    const handleCloseDialog = () => {
        setIsDialogOpen(false)
    }

    const handleOpenDialog = () => {
        setIsDialogOpen(true)
    }
    return (
        <>
            <Button variant='contained' onClick={handleOpenDialog} style={{ maxHeight: 30, marginRight: theme.spacing(2) }}>{dialogType === 'multiple' ? 'Zaplatit vše' : 'zaplatit'}</Button>
            <Dialog open={isDialogOpen} onClose={handleCloseDialog}>
                <img
                    src={UnsavedChangesWarningImage}
                    alt='unsavedChangesImage'
                    width={195}
                    style={{ margin: 'auto', marginTop: theme.spacing(3) }}
                />
                <DialogTitle textAlign='center'>Chcete potvrdit, že má kontakt zaplaceno? </DialogTitle>
                <DialogActions>
                    <Button onClick={handleCloseDialog} variant='outlined'>
                        Zrušit
                    </Button>
                    <Button
                        onClick={() => {
                            onContractorPaid()
                            handleCloseDialog()
                        }}
                        variant='contained'
                    >
                        Zaplatit
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    )
}

export default PayContractorDialog
